import { CollectionView } from 'backbone.marionette';
import RoundStatItem from '../RoundStatItem';

export class RoundsStats extends CollectionView {
	get childView() {
		return RoundStatItem;
	}

	get childViewOptions() {
		return {
			match_stat: this.options.match_stat
		}
	}
}

export default RoundsStats;